import { render, staticRenderFns } from "./EducationPanel.vue?vue&type=template&id=7f82d3a0&scoped=true&"
import script from "./EducationPanel.vue?vue&type=script&lang=ts&"
export * from "./EducationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./EducationPanel.vue?vue&type=style&index=0&id=7f82d3a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f82d3a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
